import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SEGURIA_LOGO =
  process.env.PUBLIC_URL + "/logo-seguria.png";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setDone(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Ocurrio un error. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8" data-testid="forgot-password-page">
        <div className="text-center">
          <img src={SEGURIA_LOGO} alt="SegurIA" className="mx-auto h-24 w-auto mb-4" onError={(e) => { e.target.style.display = "none"; }} />
          <h2 className="text-2xl font-extrabold text-gray-900">
            Recuperar contraseña
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Te enviaremos un email con instrucciones para crear una nueva contraseña.
          </p>
        </div>

        {done ? (
          <div className="rounded-md bg-green-50 border border-green-200 p-6 text-center" data-testid="forgot-password-success">
            <p className="text-sm text-green-800 font-medium leading-relaxed">
              Si el email <strong>{email}</strong> está registrado en SegurIA, recibirás un correo con un link para restablecer tu contraseña.
            </p>
            <p className="text-xs text-green-700 mt-3">
              Revisa también la carpeta de spam. El link expira en 1 hora.
            </p>
            <button
              type="button"
              onClick={() => { window.location.href = "/"; }}
              className="mt-5 inline-block px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md"
              data-testid="back-to-login-btn"
            >
              Volver al inicio
            </button>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="rounded-md bg-red-50 p-4" data-testid="forgot-password-error">
                <h3 className="text-sm font-medium text-red-800">{error}</h3>
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="tu@empresa.com"
                data-testid="forgot-password-email-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading || !email.trim()}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="forgot-password-submit-btn"
            >
              {loading ? "Enviando..." : "Enviar instrucciones"}
            </button>

            <div className="text-center">
              <a
                href="/"
                className="text-sm font-medium text-blue-600 hover:text-blue-500"
                data-testid="forgot-password-back-link"
              >
                Volver al login
              </a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
